module.exports = __webpack_public_path__ + "static/media/step14.700f1e9a.png";